
const getters = {
  getCreditById: (state, getters, rootState, rootGetters) => (id) => {
    console.log(state['moduleCredit'].credits)
    // return rootState.moduleCredit.credits.find(credit => credit.id === id)
  },
  // credits: state => state.credits,
}
export default getters